import { Button, Col, Divider, Form, Modal, Switch, Row, Space, Tooltip } from "antd"
import { FormDatePicker, FormInput, FormSelect, RequiredMark } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useTranslation } from "react-i18next"
import { InfoCircleOutlined } from "@ant-design/icons"
import { useEffect, useState } from "react";

const PeriodEditModal = ({
    isModalOpen = false,
    handleOk = () => { },
    onCancel = () => { },
    updatePayrollPeriod = () => { },
    initialValues = {},
    form = null,
    employmentTypeDropdown = () => { },
    onEditSubmit = () => { }
}) => {
    const { t, i18n } = useTranslation();

    const formItemLayout = {
        labelAlign: "left", labelCol: { span: 7 },
    }
    const [checked, setChecked] = useState(false);

    const handleChange = (checked) => {
        if (initialValues.offCyclePayroll) {
            setChecked(initialValues.offCyclePayroll)
        }
        setChecked(checked);
    };

    console.log("updatePayrollPeriod", initialValues);

    useEffect(() => {
        if (initialValues) {
            form.setFieldsValue({ ...initialValues })
        }
    }, [initialValues, form])

    const tooltipText = <span>{i18n.language === "en" ? "To calculate the income or deduction which are made outside of the regular period and paid in the current period." : "ระบบจะคำนวณรายได้หรือรายหักตามช่วงเวลานอกงวดที่กำหนดและทำจ่ายพร้อมงวดเงินเดือนปัจจุบัน"}</span>

    return (
        <Modal
            destroyOnClose
            title={t("payroll_period.edit_period")}
            open={isModalOpen}
            onOk={handleOk}
            onCancel={() => {
                const cancelBtn = document.getElementById(
                    "cancelBtn"
                );
                if (cancelBtn) {
                    cancelBtn.click();
                } else {
                    onCancel();
                }
            }}
            style={{
                body: {
                    maxHeight: "65vh",
                    overflowY: "auto",
                    overflowX: "hidden",
                    scrollbarWidth: "none",
                }
            }}
            footer={null}
        >
            <FormAntd
                form={form}
                initialValues={{ ...initialValues }}
                colon={false}
                requiredMark={RequiredMark}
                onFinish={onEditSubmit}
            >
                <Divider />
                <Form.Item shouldUpdate
                    formItemLayout={formItemLayout}>
                    {({ submit, getFieldsValue, getFieldValue, setFieldValue = () => { } }) => {
                        return (

                            <>
                                <Row gutter={24}>
                                    <Col span={18}>
                                        <FormInput
                                            label={t("payroll_period.label.period_no")}
                                            fontWeight="bold"
                                            name="periodNo"
                                            size="large"
                                            disabled
                                            vertical={false}
                                            formItemLayout={formItemLayout}
                                            variant="borderless"
                                        />
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={18}>
                                        <FormInput
                                            label={t("payroll_period.label.month")}
                                            fontWeight="bold"
                                            name="month"
                                            size="large"
                                            disabled
                                            vertical={false}
                                            formItemLayout={formItemLayout}
                                            variant="borderless"
                                        />
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={18}>
                                        <FormSelect
                                            label={t("payroll_period.label.employment_type")}
                                            fontWeight="bold"
                                            name="employmentTypeId"
                                            size="large"
                                            disabled
                                            vertical={false}
                                            mode="multiple"
                                            variant="filled"
                                            formItemLayout={formItemLayout} />
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={18}>
                                        <FormDatePicker
                                            required
                                            name="datePeriodDayjs"
                                            label={t("payroll_period.label.cal_date")}
                                            labelCol={{ span: 24 }}
                                            type="range"
                                            placeholder="Please Select"
                                            size="large"
                                        />
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={18}>
                                        <FormDatePicker
                                            required
                                            name="paymentDateDayjs"
                                            label={t("payroll_period.label.payment_date")}
                                            labelCol={{ span: 24 }}
                                            placeholder="Please Select"
                                            size="large"
                                        />
                                    </Col>
                                </Row>
                                <Divider />
                                <Form.Item name="openCondition" label={
                                    <Space>
                                        {t("payroll_period.label.off_cycle")}
                                        <Tooltip title={tooltipText} color="#4EB8E0">
                                            <InfoCircleOutlined />
                                        </Tooltip>
                                    </Space>

                                }>
                                    <Switch
                                        checked={checked}
                                        onChange={handleChange}
                                        name="offCyclePayroll" label="" />
                                </Form.Item>

                                {checked ?
                                    <Row gutter={24}>
                                        <Col span={18}>
                                            <FormDatePicker
                                                required
                                                name="extendDateDayjs"
                                                label={t("payroll_period.label.date_extend")}
                                                labelCol={{ span: 24 }}
                                                type="range"
                                                placeholder="Please Select"
                                                size="large"
                                            />
                                        </Col>
                                    </Row>
                                    : null}
                                <Col span={12} style={{ marginTop: "24px" }}>
                                    <Row>
                                        <span>{t("payroll_period.last_modified")}</span>
                                    </Row>
                                    <Row>
                                        <span>{initialValues?.lastModifiedName}</span>
                                    </Row>
                                    <Row>
                                        <span>{initialValues?.lastModifiedDate}</span>
                                    </Row>
                                </Col>
                                <Row style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
                                    <Button
                                        id="cancelBtn"
                                        type="default"
                                        key="cancleBtn"
                                        onClick={() => {
                                            onCancel();
                                        }}
                                    >
                                        {t("payroll_period.label.cancel")}
                                    </Button>
                                    <Button
                                        onClick={() => { console.log("submit"); submit() }}
                                        type="primary"
                                    >
                                        {t("payroll_period.label.confirm")}
                                    </Button>
                                </Row>
                            </>
                        )
                    }}
                </Form.Item>
            </FormAntd >
        </Modal >

    );
}

export default PeriodEditModal;